import React from 'react';
import { useStyletron } from 'baseui';
import { Button, KIND, SIZE } from 'baseui/button';
import { DataList, Loader, CustomModal } from 'commons-ui';

import useDashboardActions from 'pages/userProfile/useUserProfileActions';
import { LIST_ENTITY_NAMES } from 'constant';
import { defaults } from '../../constants';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import DateRangeFilter from './DateRangeFilter';
import useList from './useList';
import { columnConfigs } from './listConfig';

const ConfiscationAndRefundList: React.FC<{}> = () => {
	const {
		getConfiscationAndRefundData,
		handleFilterSubmit,
		forceUpdate,
		showLoader,
		setShowLoader,
		fetchConfiscationAndRefundData,
		handleDownloadData
	} = useList();
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList, {
		setShowLoader,
		fetchConfiscationAndRefundData
	});
	const actions = getActionList();
	const [css] = useStyletron();
	return (
		<>
			{showLoader && <Loader />}
			<div
				className={css({
					height: '60px',
					display: 'flex',
					alignItems: 'center',
					backgroundColor: 'white',
					paddingLeft: '10px',
					borderTop: '1px solid rgb(242, 242, 242)',
					justifyContent: 'space-between',
					width: '100vw'
				})}>
				<DateRangeFilter onSubmit={handleFilterSubmit} />
				<div title='download' className={css({ padding: '6px 200px' })}>
					<Button kind={KIND.primary} size={SIZE.compact} onClick={handleDownloadData}>
						Download CSV
					</Button>
				</div>
			</div>
			<DataList
				fetchData={getConfiscationAndRefundData}
				columnConfigs={columnConfigs}
				getActionHandler={getActionHandler}
				actions={actions}
				entity={LIST_ENTITY_NAMES.CONFISCATION_AND_REFUND}
				globalForceUpdate={forceUpdate}
				disablePagination={false}
				disablePaginationSelect
				defaults={defaults}
				height='calc(100vh - 220px)'
			/>
			<CustomModal />
		</>
	);
};

export default ConfiscationAndRefundList;
